import { render, staticRenderFns } from "./ManageType.vue?vue&type=template&id=6bfd395b&"
import script from "./ManageType.vue?vue&type=script&lang=js&"
export * from "./ManageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports